var map = {
	"./fluent-apps-24-regular.svg": "501b",
	"./fluent-document-24-regular.svg": "64e3",
	"./fluent-document-bullet-list-24-regular.svg": "98f0",
	"./fluent-document-pdf-24-regular.svg": "3c29",
	"./fluent-document-table-24-regular.svg": "2f60",
	"./fluent-folder-zip-24-regular.svg": "950e",
	"./fluent-image-24-regular.svg": "459b",
	"./fluent-music-note-1-24-regular.svg": "ac0b",
	"./fluent-slide-multiple-24-regular.svg": "31b1",
	"./fluent-text-font-20-regular.svg": "c85a",
	"./fluent-video-clip-24-regular.svg": "e760"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc6d";